import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=cb94cd6e&scoped=true&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"
import style0 from "./preview.vue?vue&type=style&index=0&id=cb94cd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb94cd6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\openy-admin-all\\openy-wxms-web2026-09-01\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb94cd6e')) {
      api.createRecord('cb94cd6e', component.options)
    } else {
      api.reload('cb94cd6e', component.options)
    }
    module.hot.accept("./preview.vue?vue&type=template&id=cb94cd6e&scoped=true&", function () {
      api.rerender('cb94cd6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/preview/preview.vue"
export default component.exports